import HideImageIcon from '@mui/icons-material/HideImage';
import { Box, CardMedia, Typography } from '@mui/material';
import { defineMessage, useIntl } from 'react-intl';

const noThumbnailMessage = defineMessage({
  id: 'fragments.videoEditions.noThumbnail',
  defaultMessage: 'Sin thumbnail',
});

/**
 * 16:9 placeholder when the project has no thumbnail URL yet.
 */
export function ProjectCardMediaPlaceholder() {
  const { formatMessage } = useIntl();

  return (
    <CardMedia
      component="div"
      sx={{
        aspectRatio: '16/9',
        bgcolor: 'grey.100',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: 1,
          color: 'grey.400',
        }}
      >
        <HideImageIcon sx={{ fontSize: 48 }} />
        <Typography variant="caption" color="text.disabled">
          {formatMessage(noThumbnailMessage)}
        </Typography>
      </Box>
    </CardMedia>
  );
}
